"use client";
import React from "react";
import { Accordion, Container } from "react-bootstrap";
import "./Dpu_Mca_Faq.css";

const Dpu_Mca_Faq = () => {
  const data = [
    {
      name: "What is the duration of the Online MCA program at DPU-COL?",
      description:
        "The program span is 2 years, and admission is valid for 4 years, divided into four semesters. Students must complete all coursework, projects, and assessments within this period.",
    },
    {
      name: "Is the Online MCA degree from DPU-COL recognized?",
      description:
        "Yes, DPU-COL is a UGC-entitled university, and the Online MCA program is AICTE-approved and recognized nationally, making it valid for both private and government sector jobs.",
    },
    {
      name: "How is the program delivered?",
      description:
        "The program is delivered 100% online through a digital LMS, featuring live sessions, recorded lectures, e-books, quizzes, and discussion forums.",
    },
    {
      name: "Do you provide placement assistance to the online students?",
      description:
        "We have a wide network of 300+ hiring partners and 150,000+ alumni across 20+ countries, providing a vast network and job opportunities for the online learning community.",
    },
    {
      name: "How are exams conducted in the Online MCA program?",
      description:
        "Exams are conducted online with remote proctoring, allowing students to appear from the comfort of their homes under strict academic integrity guidelines.",
    },
  ];

  return (
    <section className="question-section Dpu_Mca_Faq">
      <Container>
        <div className="col-lg-12 text-center ">
          <h2 className="section_heading">FAQ</h2>
        </div>

        <div className="questions">
          <Accordion defaultActiveKey="0">
            {data?.map((val, index) => (
              <Accordion.Item key={index} eventKey={index.toString()}>
                <Accordion.Header>{val?.name}</Accordion.Header>
                <Accordion.Body>
                  <p>{val?.description}</p>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </Container>
    </section>
  );
};

export default Dpu_Mca_Faq;
